<!-- src/components/CustomMessageModal.vue -->
<template>
  <div class="custom-message-wrapper">
    <transition-group name="message-modal-fade" tag="div">
      <div
          v-for="message in messages"
          :key="message.id"
          class="custom-message-overlay"
          @click.self="handleOverlayClick"
      >
        <div class="custom-message-modal">
          <button
              class="custom-message-modal-close"
              @click="closeMessage(message.id)"
          >
            <span class="custom-message-modal-close-x"></span>
          </button>

          <div class="custom-message-modal-content">
            <!-- 图标区域 -->
            <div class="custom-message-icon-container">
              <div :class="['custom-message-icon-outer', `custom-message-icon-outer-${message.type}`]">
                <i :class="getIconClass(message.type)"></i>
              </div>
            </div>

            <!-- 内容区域 -->
            <div class="custom-message-content-wrapper">
              <div class="custom-message-content" v-html="formatContent(message.content)"></div>
            </div>

            <!-- 按钮区域 -->
            <div class="custom-message-footer">
              <button
                  :class="['custom-message-button', `custom-message-button-${message.type}`]"
                  @click="handleConfirm(message)"
              >
                {{ message.buttonText || 'OK' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition-group>

    <audio ref="successAudio">
      <source :src="require('../../assets/scan_success.mp3')" type="audio/mpeg">
    </audio>
    <audio ref="warningAudio">
      <source :src="require('../../assets/warning.mp3')" type="audio/mpeg">
    </audio>
    <audio ref="errorAudio">
      <source :src="require('../../assets/mm.mp3')" type="audio/mpeg">
    </audio>
  </div>
</template>


<script>
export default {
  name: 'CustomMessageModal',
  data() {
    return {
      messages: [],
      seed: 0
    }
  },
  watch: {
    messages: {
      handler(newVal) {
        if (newVal.length > 0) {
          // 消息显示时添加事件监听器
          this.addEventListeners();
          // 禁用背景元素的交互
          this.disableBackgroundInteraction();
        } else {
          // 消息关闭时移除事件监听器
          this.removeEventListeners();
          // 恢复背景元素的交互
          this.enableBackgroundInteraction();
        }
      },
      deep: true
    }
  },
  methods: {
    success(content, duration, callback) {
      // 支持 this.$message.success(content, duration, callback)
      // 和 this.$message.success(content, callback)
      let actualDuration = 0;
      let actualCallback = null;

      if (typeof duration === 'function') {
        // 第二个参数是回调函数
        actualCallback = duration;
      } else {
        // 第二个参数是持续时间
        actualDuration = duration;
        actualCallback = callback;
      }

      if (typeof content === 'object') {
        this.addMessage('success', content.content, content.duration, content.callback || actualCallback);
      } else {
        this.addMessage('success', content, actualDuration, actualCallback);
      }
      this.$nextTick(() => {
        this.$refs.successAudio.play().catch(e => console.log('播放成功提示音失败:', e));
      });
    },

    warning(content, duration, callback) {
      let actualDuration = 0;
      let actualCallback = null;

      if (typeof duration === 'function') {
        actualCallback = duration;
      } else {
        actualDuration = duration;
        actualCallback = callback;
      }

      if (typeof content === 'object') {
        this.addMessage('warning', content.content, content.duration, content.callback || actualCallback);
      } else {
        this.addMessage('warning', content, actualDuration, actualCallback);
      }
      this.$nextTick(() => {
        this.$refs.warningAudio.play().catch(e => console.log('播放警告提示音失败:', e));
      });
    },

    error(content, duration, callback) {
      let actualDuration = 0;
      let actualCallback = null;

      if (typeof duration === 'function') {
        actualCallback = duration;
      } else {
        actualDuration = duration;
        actualCallback = callback;
      }

      if (typeof content === 'object') {
        this.addMessage('error', content.content, content.duration, content.callback || actualCallback);
      } else {
        this.addMessage('error', content, actualDuration, actualCallback);
      }
      this.$nextTick(() => {
        this.$refs.errorAudio.play().catch(e => console.log('播放警告提示音失败:', e));
      });
    },

    info(content, duration, callback) {
      let actualDuration = 0;
      let actualCallback = null;

      if (typeof duration === 'function') {
        actualCallback = duration;
      } else {
        actualDuration = duration;
        actualCallback = callback;
      }

      if (typeof content === 'object') {
        this.addMessage('info', content.content, content.duration, content.callback || actualCallback);
      } else {
        this.addMessage('info', content, actualDuration, actualCallback);
      }
    },

    addMessage(type, content, duration = 0, callback = null) {
      const id = `message_${this.seed++}`;
      const message = {
        id,
        type,
        content,
        duration,
        callback, // 保存回调函数
        executed: false // 添加标记，确保回调函数只执行一次
      };

      this.messages.push(message);
    },

    closeMessage(id) {
      const index = this.messages.findIndex(msg => msg.id === id);
      if (index !== -1) {
        const message = this.messages[index];
        // 如果有回调函数且尚未执行，则执行回调函数
        if (typeof message.callback === 'function' && !message.executed) {
          message.executed = true; // 标记回调函数已执行
          message.callback();
        }
        this.messages.splice(index, 1);
      }
    },

    // 新增方法：处理确认按钮点击
    handleConfirm(message) {
      // 关闭消息（closeMessage方法中会处理回调函数的执行）
      this.closeMessage(message.id);
    },

    getIconClass(type) {
      const iconMap = {
        success: 'custom-message-icon-check',
        warning: 'custom-message-icon-warning',
        error: 'custom-message-icon-error',
        info: 'custom-message-icon-info'
      };
      return `custom-message-icon ${iconMap[type]}`;
    },

    formatContent(content) {
      if (!content) return '';

      // 处理换行符和制表符
      let formatted = content
          .replace(/\n/g, '<br>')
          .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');

      return formatted;
    },

    // 添加事件监听器
    addEventListeners() {
      document.addEventListener('keydown', this.handleKeydown, true);
    },

    // 移除事件监听器
    removeEventListeners() {
      document.removeEventListener('keydown', this.handleKeydown, true);
    },

    // 处理键盘事件
    handleKeydown(event) {
      // 处理 ESC 键关闭消息
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();

        // 如果有消息显示，按 ESC 键时关闭最新消息
        if (this.messages.length > 0) {
          const latestMessage = this.messages[this.messages.length - 1];
          this.closeMessage(latestMessage.id);
        }
        return;
      }

      // 处理 Enter 键确认操作（移除原来的自动确认功能）
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        // 不再自动触发确认操作，需要用户点击确认按钮
      }
    },

    // 处理蒙层点击事件
    handleOverlayClick(event) {
      event.stopPropagation();
    },

    // 禁用背景元素的交互
    disableBackgroundInteraction() {
      // 给body添加一个类，用于禁用背景交互
      document.body.classList.add('custom-message-modal-open');

      // 保存当前焦点元素
      this.lastActiveElement = document.activeElement;

      // 移除所有非模态框内元素的焦点
      if (this.lastActiveElement && !this.isModalElement(this.lastActiveElement)) {
        this.lastActiveElement.blur();
      }
    },

    // 恢复背景元素的交互
    enableBackgroundInteraction() {
      // 移除body上的类
      document.body.classList.remove('custom-message-modal-open');

      // 恢复焦点到之前的元素（如果需要）
      // 这里不自动恢复焦点，因为可能已经不在原来的上下文中
    },

    // 判断元素是否属于模态框
    isModalElement(element) {
      // 检查元素是否在模态框内
      return element.closest('.custom-message-modal') !== null;
    }
  },

  beforeDestroy() {
    // 组件销毁前移除事件监听器
    this.removeEventListeners();
    // 确保清理掉可能添加的类
    document.body.classList.remove('custom-message-modal-open');
  }
}
</script>


<style scoped>
/* 样式部分保持不变 */
.custom-message-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  pointer-events: none;
}

.custom-message-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  pointer-events: auto;
  z-index: 10000;
  padding-bottom: 60vh;
}

.custom-message-modal {
  background: #fff;
  border-radius: 8px; /* 四个角改为圆角 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 500px;
  max-width: calc(100vw - 32px);
  pointer-events: auto;
  position: relative;
  margin: 0 20px;
}

.custom-message-modal-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 0;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-message-modal-close:hover {
  color: rgba(0, 0, 0, 0.7);
}

.custom-message-modal-close-x {
  display: block;
  width: 14px;
  height: 14px;
  position: relative;
}

.custom-message-modal-close-x::before,
.custom-message-modal-close-x::after {
  content: '';
  position: absolute;
  top: 7px;
  left: 0;
  width: 14px;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.45);
  transition: background-color 0.3s;
}

.custom-message-modal-close-x::before {
  transform: rotate(45deg);
}

.custom-message-modal-close-x::after {
  transform: rotate(-45deg);
}

.custom-message-modal-close:hover .custom-message-modal-close-x::before,
.custom-message-modal-close:hover .custom-message-modal-close-x::after {
  background-color: rgba(0, 0, 0, 0.7);
}

.custom-message-modal-content {
  padding: 24px;
  text-align: center; /* 内容居中 */
}

/* 修改内容包装器，用于显示最多三行内容 */
.custom-message-content-wrapper {
  max-height: calc(20px * 1.5 * 3); /* font-size * line-height * 3行 */
  overflow-y: auto;
  margin-bottom: 24px;
}

.custom-message-icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.custom-message-icon-outer {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  border: 2px solid;
}

.custom-message-icon-outer-success {
  border-color: #52c41a;
  color: #52c41a;
}

.custom-message-icon-outer-warning {
  border-color: #faad14;
  color: #faad14;
}

.custom-message-icon-outer-error {
  border-color: #ff4d4f;
  color: #ff4d4f;
}

.custom-message-icon-outer-info {
  border-color: #1890ff;
  color: #1890ff;
}

.custom-message-icon {
  font-weight: bold;
  width: 90%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
}

.custom-message-icon-check::before {
  content: "✓";
}

.custom-message-icon-warning::before {
  content: "!";
}

.custom-message-icon-error::before {
  content: "×";
}

.custom-message-icon-info::before {
  content: "i";
}

.custom-message-content {
  font-size: 20px;
  text-align: center; /* 内容居中 */
  line-height: 1.5;
  word-wrap: break-word;
  white-space: pre-wrap;
  color: rgba(0, 0, 0, 0.85);
}

.custom-message-footer {
  display: flex;
  justify-content: center; /* 按钮居中 */
}

.custom-message-button {
  padding: 0 15px;
  height: 32px;
  line-height: 30px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 20px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s;
}

.custom-message-button-success {
  color: #52c41a;
  background: #f6ffed;
  border-color: #b7eb8f;
}

.custom-message-button-success:hover {
  color: #73d13d;
  border-color: #73d13d;
}

.custom-message-button-warning {
  color: #faad14;
  background: #fffbe6;
  border-color: #ffe58f;
}

.custom-message-button-warning:hover {
  color: #ffc53d;
  border-color: #ffc53d;
}

.custom-message-button-error {
  color: #ff4d4f;
  background: #fff2f0;
  border-color: #ffccc7;
}

.custom-message-button-error:hover {
  color: #ff7875;
  border-color: #ff7875;
}

.custom-message-button-info {
  color: #1890ff;
  background: #e6f7ff;
  border-color: #91d5ff;
}

.custom-message-button-info:hover {
  color: #40a9ff;
  border-color: #40a9ff;
}

.message-modal-fade-enter-active, .message-modal-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.message-modal-fade-enter, .message-modal-fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.message-modal-fade-enter .custom-message-overlay, .message-modal-fade-leave-to .custom-message-overlay {
  opacity: 0;
}
</style>






<style>/* 禁用背景交互的样式 */
.custom-message-modal-open {
  /* 禁用所有背景元素的指针事件 */
  pointer-events: none;
}

/* 确保模态框及其子元素仍然可以交互 */
.custom-message-modal-open .custom-message-wrapper,
.custom-message-modal-open .custom-message-wrapper * {
  pointer-events: auto;
}
</style>